import { InstallationDb } from '../../indexed_db/installMeterDb';

let installMeterDb: InstallationDb;

const installMeterDbFactory = () => (installMeterDb = new InstallationDb());

/**
 * @deprecated Use `useServices` hook instead.
 */
export const getInstallMeterDbApi = (): InstallationDb => installMeterDb ?? installMeterDbFactory();
